/**
 * Module dependencies.
 */

import { LastLineProps } from 'app/components/organisms/crud/form-types';
import { formatCurrency } from 'app/core/utils/formatter';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Field } from 'app/components/organisms/field/field';

/**
 * Sum fields shown in the footer.
 */

const SUM_FIELDS = ['total', 'normal', 'splitTransaction', 'switchAccount', 'valueReposition'];

/**
 * Export `TableFooter` component.
 *
 * Shows aggregated sums for the current filters (computed on the API over the
 * whole filtered set, not just the visible page).
 */

export function TableFooter({ summary }: LastLineProps): JSX.Element | null {
  const [translate] = useTranslation();

  if (!summary) {
    return null;
  }

  return (
    <div
      className={
        'contents max-[600px]:flex max-[600px]:flex-col max-[600px]:rounded-lg max-[600px]:overflow-hidden max-[600px]:shadow-[0px_0px_5px_0px_rgba(0,0,0,0.30)] max-[600px]:mb-4 max-[600px]:p-4 max-[600px]:bg-[#f2f2f2]'
      }
    >
      <div className={'col-[5/9] pr-[50px] pt-10'}>
        <Field title={translate('common.labels.items')} value={String(summary.count ?? 0)} />

        {SUM_FIELDS.map(key => (
          <Field key={key} title={translate(`common.labels.${key}`)} value={formatCurrency(summary[key] ?? 0)} />
        ))}
      </div>
    </div>
  );
}
